var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"layout-container pa-0"},[_c('SenderSettings'),_c('v-divider',{staticClass:"my-4"}),_c('DomainSettings')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }